import styled from 'styled-components';

export const ContainerCheckBox = styled.div`
  margin: 5px;
`;
